export const VERSION = 'local';
